import { render, staticRenderFns } from "./SubCatalogsSidebar.vue?vue&type=template&id=7654d5a7&scoped=true"
import script from "./SubCatalogsSidebar.vue?vue&type=script&lang=js"
export * from "./SubCatalogsSidebar.vue?vue&type=script&lang=js"
import style0 from "./SubCatalogsSidebar.vue?vue&type=style&index=0&id=7654d5a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7654d5a7",
  null
  
)

export default component.exports